import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Router, ActivatedRoute } from '@angular/router';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { calendarES } from '../../../../../theme/functions/calendarES';
import { formatDate } from '../../../../../theme/functions/formatDate.function';

import { MedicalCase } from '../../../class/medical-case';
import { MedicalCasesService } from '../../../service/medical-cases/medical-cases.service';

import { ProfileSurveyService } from '../../../service/profile-survey/profile-survey.service';
import { CustomerGuideService } from '../../../service/customer-guide/customer-guide.service';
import { MedicalCaseEventCandidateSharedService } from '../../../service/medical-case-event-candidate/medical-case-event-candidate-shared.service';
import { Observable } from 'rxjs/Observable';


@Component({
  selector: 'app-new-medical-case',
  templateUrl: './new-medical-case.component.html',
  styleUrls: ['./new-medical-case.component.scss']
})
export class NewMedicalCaseComponent implements OnInit, OnChanges {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() edit: MedicalCase;

  public isDownloadingPdf = false;

  private id: number;
  public showPage: number;

  public promiseForm: Promise<any>;
  public form: FormGroup;

  public es: any;

  public save_exit: boolean;

  public myEmployeeId: string;

  public originOptions: any[] = [];
  public typeOptions: any[] = [];

  public monitoringOptions: any[];
  public levelAccidentOptions: any[];
  public basicOptions: any[];
  public pclOptions: any[];
  public rehabilitationConceptOptions: any[];
  public takesCaseOptions: any[];
  public statusOptions: any[];
  public moreDocumentSections: any[];
  public groupedDocumentSections: any[];

  public selectedOrigin: any;
  public candidate_id: string;

  public dataGeneral: any;
  listDocuments: any;

  constructor(
    public fb: FormBuilder,
    public medicalCasesService: MedicalCasesService,
    public translate: TranslateService,
    public router: Router,
    private route: ActivatedRoute,
    public profileSurveyService: ProfileSurveyService,
    public customerGuideService: CustomerGuideService,
    public hasPermissionService: HasPermissionService,
    private notificationsService: NotificationsService,
    public medicalCaseEventCandidateSharedService: MedicalCaseEventCandidateSharedService,
    private ngZone: NgZone
  ) {
    this.save_exit = false;

    this.es = calendarES();

    this.originOptions = [
      { label: 'Común', value: 'Común' },
      { label: 'Laboral', value: 'Laboral' }
    ];

    this.typeOptions = [
      { label: "Calificado por retirar", value: "Calificado por retirar" },
      { label: "Embarazada", value: "Embarazada" },
      { label: "Enfermedad común (fuero)", value: "Enfermedad común (fuero)" },
      { label: "Enfermedad laboral", value: "Enfermedad laboral" },
      { label: "Fuero de lactancia", value: "Fuero de lactancia" },
      { label: "Fuero paterno", value: "Fuero paterno" },
      { label: "Fuero por AT", value: "Fuero por AT" },
      { label: "Fuero por AT (ELR)", value: "Fuero por AT (ELR)" },
      { label: "Licencia materna", value: "Licencia materna" },
      { label: "Retiro autorizado", value: "Retiro autorizado" },
      { label: "Fuero Prepensionado", value: "Fuero Prepensionado" }
    ];

    this.levelAccidentOptions = [
      { label: 'Leve', value: 'Leve' },
      { label: 'Grave', value: 'Grave' },
      { label: 'Severo', value: 'Severo' }
    ];


    this.monitoringOptions = [
      { label: 'Presencial', value: 'Presencial' },
      { label: 'Telefónico', value: 'Telefónico' },
      { label: 'Virtual', value: 'Virtual' },
    ];
    this.basicOptions = [
      { label: 'Si', value: 'Si' },
      { label: 'No', value: 'No' },
      //{label: 'No Aplica', value: 'No Aplica'},
    ];
    this.pclOptions = [
      { label: 'EPS', value: 'EPS' },
      { label: 'AFP', value: 'AFP' },
      { label: 'ARL', value: 'ARL' },
      { label: 'JRCI', value: 'JRCI' },
      { label: 'JCNI', value: 'JCNI' },
    ];
    this.rehabilitationConceptOptions = [
      { label: 'Favorable', value: 'Favorable' },
      { label: 'Desfavorable', value: 'Desfavorable' },
    ];
    this.takesCaseOptions = [
      { label: 'Cliente', value: 'Cliente' },
      { label: 'Redes', value: 'Redes' },
      { label: 'Compartido', value: 'Compartido' },
    ];
    this.statusOptions = [
      { label: 'Abierto', value: 'Abierto' },
      { label: 'Cerrado', value: 'Cerrado' },
    ];

    this.moreDocumentSections = [
      { id: 6, label: 'Current supports (current year)', isRequired: true },
      { id: 7, label: 'Relocation announcement' },
      { id: 8, label: 'Lifting of restrictions' },
      { id: 9, label: 'Announcement of reassignment of functions' },
      { id: 10, label: 'Announcement of 180 days of incapacity' },
      { id: 11, label: 'Supporting documents from previous periods' },
      { id: 12, label: 'Work accident report' },
      { id: 13, label: 'Work accident investigation' },
      { id: 14, label: 'Action plans' },
      // { id: 15, label: 'Ministry of Labor report' },
    ];
    this.groupedDocumentSections = this.chunkArray(this.moreDocumentSections, 2);
  }

  ngOnInit() {
    this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
    this.id = +this.route.snapshot.paramMap.get('event_id');

    if (this.id !== 0 && (this.id !== undefined)) {
      this.candidate_id = this.route.snapshot.paramMap.get('candidate_id');
      this.medicalCaseEventCandidateSharedService.fetchDataById(this.candidate_id).subscribe(candidate => {
        this.dataGeneral = candidate;
      });
      var promiseLoc = this.medicalCasesService.infoMedicalCase(this.id).toPromise().then(
        response => {
          this.edit = response.json();
          this.createForm(this.edit);
          this.showPage = 1;
        },
        error => {
          this.notificationsService.growlNotify('error', 'ID ' + this.id + ' no encontrado');
          this.router.navigateByUrl('/pages/medical-cases');
          // this.showPage = 1;
        }
      );
    }
    else {
      this.createForm();
      this.showPage = 1;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  createForm(data: any = null) {
    data = data || {
      id: undefined,
      monitoring_start: null,
      monitoring_end: null,
      origin: '',
      level_accident: null,
      type: '',
      candidate_id: null,
      employee_eps: null,
      diagnostic: null,
      exam_post: '',
      exam_post_date: '',
      // exam_post_attach:'',
      exam_periodic: '',
      exam_periodic_date: '',
      pcl: '',
      pcl_date: null,
      // pcl_attach:'',
      rehabilitation_concept: '',
      rehabilitation_concept_date: '',
      extension_letter: '',
      // extension_letter_attach:'',
      support: '',
      takes_case: '',
      billing: '',
      bill_payment: '',
      status: 'Abierto',
      medical_case_events_tracking: []
    };

    this.form = this.fb.group({
      id: new FormControl(data.id),
      monitoring_start: new FormControl(data.monitoring_start ? new Date(data.monitoring_start) : null, Validators.compose([Validators.required])),
      monitoring_end: new FormControl(data.monitoring_end ? new Date(data.monitoring_end) : null),
      origin: new FormControl(data.origin, Validators.compose([Validators.required])),
      level_accident: new FormControl(data.level_accident),
      type: new FormControl(data.type, Validators.compose([Validators.required])),
      candidate_id: new FormControl(data.candidate_id, this.edit ? [] : Validators.compose([Validators.required])),
      employee_eps: new FormControl(data.employee_eps),
      diagnostic: new FormControl(data.diagnostic, Validators.compose([Validators.required, Validators.minLength(1)])),
      exam_post: new FormControl(data.exam_post, Validators.compose([Validators.required])),
      exam_post_date: new FormControl(data.exam_post_date ? new Date(data.exam_post_date) : null),
      // exam_post_attach:new FormControl (data.exam_post_attach, Validators.compose([ Validators.required ])),
      exam_periodic: new FormControl(data.exam_periodic, Validators.compose([Validators.required])),
      exam_periodic_date: new FormControl(data.exam_periodic_date ? new Date(data.exam_periodic_date) : null),
      // exam_periodic_attach:new FormControl (data.exam_periodic_attach),
      pcl: new FormControl(data.pcl.split(',')),
      pcl_date: new FormControl(data.pcl_date ? new Date(data.pcl_date) : null),
      // pcl_attach:new FormControl (data.pcl_attach),
      rehabilitation_concept: new FormControl(data.rehabilitation_concept),
      rehabilitation_concept_date: new FormControl(data.rehabilitation_concept_date ? new Date(data.rehabilitation_concept_date) : null),
      extension_letter: new FormControl(data.extension_letter, Validators.compose([Validators.required])),
      // extension_letter_attach:new FormControl (data.extension_letter, Validators.compose([ Validators.required ])),
      takes_case: new FormControl(data.takes_case, Validators.compose([Validators.required])),
      billing: new FormControl(data.billing, Validators.compose([Validators.required])),
      bill_payment: new FormControl(data.bill_payment, Validators.compose([Validators.required])),
      status: new FormControl(data.status, Validators.compose([Validators.required])),

      medical_case_events_tracking: this.fb.array(data.medical_case_events_tracking.map(tracking => this.createCaseTracking(tracking))),

    });
    const initialLevelAccident = this.form.get('level_accident').value;
    this.updateaddConditionalDocument(initialLevelAccident);

    this.onOriginChange();
    this.onLevelAccidentChange();
  }

  public newMedicalCase(values) {
    values.candidate_id = values.candidate_id ? values.candidate_id.id : this.edit.candidate_id;
    values.medical_case_events_tracking.forEach(element => {
      element.created_by_id = element.created_by_id ? (element.created_by_id.id ? element.created_by_id.id : element.created_by_id) : undefined;
      element.monitoring_date = (element.monitoring_date) ? formatDate(element.monitoring_date) : null;
      element.next_monitoring_date = (element.next_monitoring_date) ? formatDate(element.next_monitoring_date) : null;
      element.incapacity_start_date = (element.incapacity_start_date) ? formatDate(element.incapacity_start_date) : null;
      element.incapacity_end_date = (element.incapacity_end_date) ? formatDate(element.incapacity_end_date) : null;
    });
    values.pcl = values.pcl.join(',');

    values.monitoring_start = (values.monitoring_start) ? formatDate(values.monitoring_start) : null;
    values.monitoring_end = (values.monitoring_end) ? formatDate(values.monitoring_end) : null;
    values.pcl_date = (values.pcl_date) ? formatDate(values.pcl_date) : null;
    values.exam_periodic_date = (values.exam_periodic_date) ? formatDate(values.exam_periodic_date) : null;
    values.exam_post_date = (values.exam_post_date) ? formatDate(values.exam_post_date) : null;
    values.rehabilitation_concept_date = (values.rehabilitation_concept_date) ? formatDate(values.rehabilitation_concept_date) : null;

    values.id = values.id == null ? undefined : values.id;

    if (values && this.form.valid) {
      const promise = (this.edit) ? this.medicalCasesService.updateMedicalCase(this.edit.id, values) : this.medicalCasesService.newMedicalCase(values);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.notificationsService.growlNotify('success', res);
            this.edit = response.json();
            // this.msg.emit( { severity: 'success', summary: res  } );
            // this.listDocuments = this.edit.medical_case_events_documents;
            this.close.emit(true);
            this.form.reset();
          });
          this.router.navigateByUrl('/pages/medical-cases');
        },
        error => {
          const errors_body = JSON.parse(error._body);

          const translations = [];

          errors_body.errors.forEach((element) => {
            let translationKey = element.detail;
            if (element.source && element.source.pointer) {
              translationKey += `, ${element.source.pointer}`;
            }

            translations.push(
              this.translate.get(translationKey).map((translation: string) => translation)
            );
          });

          Observable.forkJoin(translations).subscribe((results: string[]) => {
            // Combina todas las traducciones en un solo string
            const combinedMessage = results.join(' ');
            this.notificationsService.growlNotify('error', combinedMessage);
          });
        }
      );
    }
  }

  public saveformMedicalCase(values) {
    this.save_exit = true;
    this.newMedicalCase(values);
  }

  public cancelMedicalCase(values) {
    this.form.reset();
    this.close.emit(true);
    if (this.candidate_id)
      this.router.navigate(['/pages/medical-cases/events/' + this.candidate_id]);
    else
      this.router.navigateByUrl('/pages/medical-cases');
  }

  public downloadPdfReport(): void {
  const caseId = this.id; 

  if (!caseId) {
    console.error('Error: No se encontró ID para descargar el caso.');
    this.notificationsService.growlNotify('error', 'Error', 'No se ha cargado un ID de caso válido.');
    return;
  }

  this.isDownloadingPdf = true;
  this.medicalCasesService.downloadPdfReport(caseId).subscribe(
    (response: any) => {
      const blob = new Blob([response.blob()], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `informe-caso-${caseId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      this.isDownloadingPdf = false;
    },
    (error) => {
      console.error('Ocurrió un error al descargar el PDF:', error);
      this.notificationsService.growlNotify('error', 'Error', 'No se pudo generar el reporte.');
      this.isDownloadingPdf = false;
    }
  );
}


  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public getDiffDate(date_start, date_end) {
    let dateStart = new Date(date_start);
    let dateEnd = new Date(date_end);

    const diff = dateEnd.getTime() - dateStart.getTime();  //msec
    return Math.ceil(diff / (1000 * 3600 * 24));
  }

  public getDisabledTypeByOrigin(form_values) {
    var status = false;
    if (form_values.value != null && form_values.value != '' && form_values.value != undefined)
      status = true;

    return status;
  }

  public typeOptionsUpdate(values) {
    if (values == 'Laboral') {
      if (!this.typeOptions.some(option => option.value === 'Accidente de trabajo'))
        this.typeOptions.push({ label: 'Accidente de trabajo', value: 'Accidente de trabajo' });
    }

    if (values == 'Común') {
      if (this.typeOptions.some(option => option.value === 'Accidente de trabajo'))
        this.typeOptions.pop();
    }
  }

  get medical_case_events_tracking() {
    return this.form.controls["medical_case_events_tracking"] as FormArray;
  }
  addCaseTracking(data: any = null) {
      this.medical_case_events_tracking.push(this.createCaseTracking({ monitoring_date: new Date() }));
      return;
  }
  createCaseTracking(data: any = null) {
    data = data || {
      id: undefined,
      monitoring_type: '',
      monitoring_date: '',
      next_monitoring_date: '',
      created_by_id: '',
      incapacity_start_date: null,
      incapacity_end_date: null,
      observations: '',
      files: []
    };
    const medical_case_events_trackingForm = this.fb.group({
      id: new FormControl(data.id),
      monitoring_type: new FormControl(data.monitoring_type, Validators.compose([Validators.required])),
      monitoring_date: new FormControl(data.monitoring_date ? new Date(data.monitoring_date) : null, Validators.compose([Validators.required])),
      next_monitoring_date: new FormControl(data.next_monitoring_date ? new Date(data.next_monitoring_date) : null),
      created_by_id: new FormControl(data.created_by_id, Validators.compose([Validators.required, Validators.minLength(5)])),
      incapacity_start_date: new FormControl(data.incapacity_start_date ? new Date(data.incapacity_start_date) : null),
      incapacity_end_date: new FormControl(data.incapacity_end_date ? new Date(data.incapacity_end_date) : null),
      observations: new FormControl(data.observations, Validators.compose([Validators.required])),
      // files: this.fb.array(data.files.map(file => this.createFile(file)))
    });

    return medical_case_events_trackingForm;

  }

  deleteCaseTracking(newCaseTrackingIndex: number) {
    this.medical_case_events_tracking.removeAt(newCaseTrackingIndex);
  }

  // createFile(file): FormGroup {
  //   return this.fb.group({
  //     file: [null],
  //     fileUrl: [file.fileUrl || '']
  //   });
  // }

  // getFiles(trackingIndex: number): FormArray {
  //   return this.medical_case_events_tracking.at(trackingIndex).get('files') as FormArray;
  // }

  // addFile(trackingIndex: number): void {
  //   this.getFiles(trackingIndex).push(this.createFile({}));
  // }

  // removeFile(trackingIndex: number, fileIndex: number): void {
  //   this.getFiles(trackingIndex).removeAt(fileIndex);
  // }

  // onFileChange(event: any, trackingIndex: number, fileIndex: number): void {
  //   const file = event.target.files[0];
  //   this.getFiles(trackingIndex).at(fileIndex).patchValue({
  //     file: file,
  //     fileUrl: '' // Limpiar la URL del archivo existente si se sube uno nuevo
  //   });
  // }

  public getDocumentsMedicalCase(medical_case_event_id: number) {
    this.medicalCasesService.getDocumentsMedicalCaseEvent(medical_case_event_id).toPromise().then(
      response => {
        // this.listDocuments = response.json();
        this.edit.medical_case_events_documents = response.json();
      },
      error => {
        this.notificationsService.growlNotify('error', "error documentos");
      }
    );
  }

  public updateDocumentsfromChild($event: Event) {
    this.getDocumentsMedicalCase(this.id);
  }

  onChangeExamPost(event) {
    console.log("hola");
  }

  updateValidator(nameControl, value) {
    var mandatory = value == 'Si' ? true : false;
    if (mandatory == true)
      this.form.get(nameControl).setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(500)]);
    else
      this.form.get(nameControl).setValidators([]);

    this.form.get(nameControl).updateValueAndValidity();
  }

  chunkArray(arr: any[], chunkSize: number) {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  }

  onOriginChange() {
    this.form.get('origin').valueChanges.subscribe(value => {
      const levelAccident = this.form.get('level_accident');

      if (value === 'Laboral') {
        // Hacer obligatorio
        levelAccident.setValidators([Validators.required]);
        levelAccident.setValue('');

      } else {
        // Quitar validación obligatoria
        levelAccident.clearValidators();
        levelAccident.setValue(null);
      }

      // Importante: actualizar el estado de validación
      levelAccident.updateValueAndValidity();
    });
  }

  onLevelAccidentChange() {
    this.form.get('level_accident').valueChanges.subscribe(value => {
      this.updateaddConditionalDocument(value);
    });
  }

  updateaddConditionalDocument(value: string) {
    const conditionalDocument = { id: 15, label: 'Ministry of Labor report', isRequired: true };

    if (value === 'Grave') {
      // Agregar objeto al array si no existe
      const exists = this.moreDocumentSections.some(doc => doc.id === conditionalDocument.id);
      if (!exists) {
        this.moreDocumentSections.push(conditionalDocument);
        this.groupedDocumentSections = this.chunkArray(this.moreDocumentSections, 2);
      }
    } else {
      // Quitar objeto del array
      this.moreDocumentSections = this.moreDocumentSections.filter(doc => doc.id !== conditionalDocument.id);
      this.groupedDocumentSections = this.chunkArray(this.moreDocumentSections, 2);
    }
  }

}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/medical-cases/new-medical-case/new-medical-case.component.ts